import React from "react";
import { Box, Typography } from "@mui/material";

export interface ConnectWisePsaGuideInnerProps {
  showGuideTitle?: boolean;
}

/**
 * ConnectWise PSA setup copy shared between onboarding and add-integration flows.
 * Grep: ConnectWise setup guide, instance URL, API member keys, Theo-managed ClientID
 */
export const ConnectWisePsaGuideInner: React.FC<ConnectWisePsaGuideInnerProps> = ({
  showGuideTitle = true,
}) => {
  return (
    <>
      {showGuideTitle ? (
        <Typography
          sx={{
            fontFamily: "var(--theo-font-sans)",
            fontWeight: 600,
            fontSize: 15,
            color: "#1a1a1a",
            mb: 1.5,
          }}
        >
          Setup Guide — ConnectWise PSA
        </Typography>
      ) : null}

      <Typography sx={{ fontFamily: "var(--theo-font-sans)", fontWeight: 600, fontSize: 14, color: "#1a1a1a", mb: 1 }}>
        Base URL
      </Typography>
      <Typography sx={{ fontFamily: "var(--theo-font-sans)", fontSize: 13, color: "#555", lineHeight: 1.5, mb: 2 }}>
        Enter your ConnectWise instance root URL.
      </Typography>

      <Typography sx={{ fontFamily: "var(--theo-font-sans)", fontWeight: 600, fontSize: 14, color: "#1a1a1a", mb: 1 }}>
        Company ID
      </Typography>
      <Typography sx={{ fontFamily: "var(--theo-font-sans)", fontSize: 13, color: "#555", lineHeight: 1.5, mb: 2 }}>
        Use the same <strong>Company ID</strong> your team enters on the ConnectWise PSA login screen.
      </Typography>

      <Typography sx={{ fontFamily: "var(--theo-font-sans)", fontWeight: 600, fontSize: 14, color: "#1a1a1a", mb: 1 }}>
        Public Key + Private Key
      </Typography>
      <Box component="ol" sx={{ m: 0, pl: 2.5, mb: 2, "& li": { mb: 0.75 } }}>
        <Typography component="li" sx={{ fontFamily: "var(--theo-font-sans)", fontSize: 13, color: "#555", lineHeight: 1.5 }}>
          In ConnectWise PSA, go to <strong>System → Members → API Members</strong>.
        </Typography>
        <Typography component="li" sx={{ fontFamily: "var(--theo-font-sans)", fontSize: 13, color: "#555", lineHeight: 1.5 }}>
          Open the API member you want Theo to use, then open the <strong>API Keys</strong> tab.
        </Typography>
        <Typography component="li" sx={{ fontFamily: "var(--theo-font-sans)", fontSize: 13, color: "#555", lineHeight: 1.5 }}>
          Click <strong>+</strong> / <strong>New Item</strong>, enter a description such as{" "}
          <Typography component="span" sx={{ fontFamily: "monospace", fontSize: 12 }}>
            Theo AI
          </Typography>
          , then save.
        </Typography>
        <Typography component="li" sx={{ fontFamily: "var(--theo-font-sans)", fontSize: 13, color: "#555", lineHeight: 1.5 }}>
          Copy the generated <strong>Public Key</strong> and <strong>Private Key</strong>.
        </Typography>
        <Typography component="li" sx={{ fontFamily: "var(--theo-font-sans)", fontSize: 13, color: "#555", lineHeight: 1.5 }}>
          The <strong>Private Key</strong> is only shown once when the key is created. If you no longer have it, create a new API key pair.
        </Typography>
      </Box>

    </>
  );
};
